import { Button, ButtonVariation } from '../../../components/Button';
import { ChevronDirection, ChevronIcon } from '../../../components/Icon';
import { useAuth } from '../../../components/auth/AuthContext';
import { ASSET_PATHS } from '../../../utils/assetPath';
import './LandingHero.css';

interface LandingHeroProps {
  showCta?: boolean;
  /**
   * Test ID for automated testing
   */
  'data-testid'?: string;
}

function LandingHero({ showCta = true, 'data-testid': dataTestId }: LandingHeroProps) {
  const { handleLogin, isLoading } = useAuth();
  const baseTestId = dataTestId ?? 'landing-hero';

  const handleLoginClick = () => {
    handleLogin();
  };

  return (
    <article
      aria-labelledby='landing-page-heading'
      className='landing-page landing-page--hero'
      data-testid={baseTestId}
      id='landing-page-content'>
      <section
        className='landing-page__hero'
        data-testid={`${baseTestId}-section`}>
        <div
          aria-hidden='true'
          className='landing-page__hero-waves'
          data-testid={`${baseTestId}-waves`}>
          <img
            alt=''
            aria-hidden='true'
            data-testid={`${baseTestId}-waves-image`}
            src={ASSET_PATHS.BLUE_WAVES_LINES}
          />
        </div>
        <div
          className='landing-page__hero-content'
          data-testid={`${baseTestId}-content`}>
          <h1
            data-testid={`${baseTestId}-title`}
            id='landing-page-heading'>
            AccessCMS
          </h1>
          <p
            className='landing-page__hero-lead'
            data-testid={`${baseTestId}-lead`}>
            <span className='landing-page__hero-lead-line'>Secured Access.</span>
            <span className='landing-page__hero-lead-line'>Empowered Users.</span>
            <span className='landing-page__hero-lead-line'>Smarter Decisions.</span>
          </p>
          {showCta && (
            <Button
              isAutoWidth
              aria-label='Log into AccessCMS'
              className='landing-page__hero-button'
              data-testid={`${baseTestId}-cta`}
              isLoading={isLoading}
              size='big'
              variation={ButtonVariation.SOLID}
              onClick={handleLoginClick}>
              Log Into AccessCMS
              <span aria-hidden='true'>
                <ChevronIcon
                  direction={ChevronDirection.RIGHT}
                  size={18}
                />
              </span>
            </Button>
          )}
        </div>
        <div
          aria-hidden='true'
          className='landing-page__hero-visual'
          data-testid={`${baseTestId}-visual`}>
          <img
            alt=''
            aria-hidden='true'
            className='landing-page__hero-graphic'
            data-testid={`${baseTestId}-graphic`}
            src={ASSET_PATHS.LANDING_PAGE_GRAPHIC}
          />
        </div>
      </section>
    </article>
  );
}

export default LandingHero;
